import styled from '@emotion/styled';

export const Header = styled.div(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  fontSize: 14,
  fontWeight: 500,
}));

export const Container = styled.div((props) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: props.theme.spacing(3),
  backgroundColor: props.theme.colors.pageWrapper,
}));

export const SubContainer = styled.div((props) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  gap: props.theme.spacing(2),
}));
